/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcquiringAuditLogsListRequest
 */
export interface AcquiringAuditLogsListRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AcquiringAuditLogsListRequest
     */
    merchantsIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof AcquiringAuditLogsListRequest
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof AcquiringAuditLogsListRequest
     */
    limit?: number;
}

export function AcquiringAuditLogsListRequestFromJSON(json: any): AcquiringAuditLogsListRequest {
    return AcquiringAuditLogsListRequestFromJSONTyped(json, false);
}

export function AcquiringAuditLogsListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquiringAuditLogsListRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'merchantsIds': !exists(json, 'merchants_ids') ? undefined : json['merchants_ids'],
        'offset': !exists(json, 'offset') ? undefined : json['offset'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
    };
}

export function AcquiringAuditLogsListRequestToJSON(value?: AcquiringAuditLogsListRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'merchants_ids': value.merchantsIds,
        'offset': value.offset,
        'limit': value.limit,
    };
}


